import axiosInstance from '../axios/axiosInstance';
import { FeedBackModel, FeedBackType } from 'interface/FeedBack';

export const FEED_BACK_PAGE_SIZE = 9;

export const findAllFeedBackType = async () => {
  const { data } = await axiosInstance.get<FeedBackType[]>('feedback/type', { params: { fromCMS: true } });
  return data;
};

export const getFeedBacks = async (url?: string) => {
  const { data } = await axiosInstance.get<any>(url || '/feedback');
  return data;
};

export const getFeedbackById = async (id?: string) => {
  const { data } = await axiosInstance.get<FeedBackModel>(`/feedback/${id}`);
  return data;
};

export const deleteFeedbackById = async (id?: string) => {
  const { data } = await axiosInstance.delete<FeedBackModel>(`/feedback/${id}`);
  return data;
};

export const sendFeedBackResponse = async (id?: string, feedbackRequest?: FeedBackModel) => {
  const { data } = await axiosInstance.put<any>(`/feedback/${id}`, feedbackRequest);
  console.log(data);
  return data;
};
